import React from 'react'
import './Floating.css'
import {themeContext} from '../../Context'
import { useContext } from "react";

export const FloatingDiv = ({image, txt1, txt2, txt3, invertOnDark = false}) => {
  
  const theme = useContext(themeContext);
  const darkMode = theme.state.darkMode;

  return (
    <div className="floatingDiv" style={{backgroundColor: darkMode? '#181818': ''}}>
        <img src={image} alt="" className={darkMode && invertOnDark ? 'floatingImageDark' : ''} />
        <span>
            {txt1}
            <br/>
            {txt2}
            {txt3 && (
                <>
                    <br/>
                    <span className="floatingSubtext">{txt3}</span>
                </>
            )}
        </span>
    </div>
  )
}
